import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import TagFacesIcon from '@material-ui/icons/TagFaces';
import { IconButton, InputBase } from '@material-ui/core';
import * as RFIcon from 'react-feather';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    margin: 0,
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
}));

export default function BaseArrayPills(props) {
  const classes = useStyles();
  const { formik, showAddHashtag, isPublished, fieldName } = props;
  const [hashtagText, setHashtagText] = useState('');

  const onAdd = (hashtag) => {
    let hashtagList = formik.values[fieldName] ? formik.values[fieldName] : []
    hashtagList.push(hashtag.toLowerCase().replaceAll(' ', ''));
    formik.setFieldValue(fieldName, hashtagList);
    setHashtagText('')
  };

  const handleDelete = (hashtag) => () => {
    let hashtagList = formik.values[fieldName]
    hashtagList.splice(hashtagList.indexOf(hashtag), 1);
    formik.setFieldValue(fieldName, hashtagList);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && hashtagText.length > 0) {
        onAdd(hashtagText)
    }
  }

  return (
    <Paper component="ul" className={classes.root}>
    {/* <TextField id='hashtagText' label='Hashtag'
                    variant="outlined"
                    value={hashtagText}
                    name='hashtagText'
                    type="text"
                    onChange={(e) => setHashtagText(e.target.value)} /> */}
        <InputBase
            type='text'
            className={classes.input}
            placeholder="Add Hashtag"
            value={hashtagText}
            inputProps={{ 'aria-label': 'naked' }}
            style={{minWidth:'100px'}}
            onChange={(e) => setHashtagText(e.target.value)}
            onKeyDown={handleKeyDown}
            disabled={isPublished}
            />
        { hashtagText.length > 0 && <IconButton disabled={isPublished} color="primary" aria-label="Add" className={classes.iconButton}
            onClick={ () => onAdd(hashtagText) }>
            <RFIcon.PlusCircle strokeWidth={1} />
        </IconButton>}
        {formik.values[fieldName] && formik.values[fieldName].length > 0 && formik.values[fieldName].map((hashtag, i) => {
            return (
            <li key={i}>
                <Chip
                label={hashtag}
                disabled={isPublished}
                onDelete={handleDelete(hashtag)}
                className={classes.chip}
                />
            </li>
            );
        })}
    </Paper>
  );
}